import React, { useEffect } from 'react';
import axios from 'axios';

function Auth({ onProfileDataFetched }) {
  const baseurl = process.env.REACT_APP_BASE_API_URL;

  // Clear local data and redirect to Signin
  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/signin";
  };

  useEffect(() => {
    const fetchProfileData = async () => {
      const authToken = localStorage.getItem('token');

      if (!authToken) {
        handleLogout();
        return;
      }

      try {
        const response = await axios.get(`${baseurl}/profile.php`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (response.data.status) {
          // If API returns success
          onProfileDataFetched(response.data.user);
        } else {
          // Token invalid or expired
          handleLogout();
        }
      } catch (error) {
        console.error("Authentication check failed", error);
        handleLogout();
      }
    };

    fetchProfileData();
  }, []); // Run only on component mount

  return null;
}

export default Auth;
